// Reminder times in the operator's day: 9:00 in Paris, whatever the browser's time zone.

const TZ = 'Europe/Paris';

export function parisParts(d: Date): { y: number; m: number; day: number; hh: number; mm: number; weekday: string } {
  const p = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
    timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', weekday: 'short', hourCycle: 'h23',
  }).formatToParts(d).map((x) => [x.type, x.value]));
  return { y: Number(p.year), m: Number(p.month), day: Number(p.day), hh: Number(p.hour), mm: Number(p.minute), weekday: p.weekday };
}

/** 09:00 in Paris, `days` after today (Paris calendar) */
export function parisNineAfter(days: number, now = new Date()): Date {
  const today = parisParts(now);
  const guess = Date.UTC(today.y, today.m - 1, today.day + days, 9, 0);
  const seen = parisParts(new Date(guess));
  const drift = Date.UTC(seen.y, seen.m - 1, seen.day, seen.hh, seen.mm) - guess;
  return new Date(guess - drift);
}

/** The reminders offered when setting a decision aside, with the time each one comes back */
export function reminderChoices(now = new Date()): Array<{ label: string; until: Date }> {
  const toMonday = { Mon: 7, Tue: 6, Wed: 5, Thu: 4, Fri: 3, Sat: 2, Sun: 1 }[parisParts(now).weekday] ?? 7;
  const choices = [{ label: 'Tomorrow 9:00', until: parisNineAfter(1, now) }];
  // Monday is « tomorrow » on Sundays, and « in a week » on Mondays: one choice is enough then
  if (toMonday > 1 && toMonday < 7) choices.push({ label: 'Monday 9:00', until: parisNineAfter(toMonday, now) });
  choices.push({ label: 'In a week', until: parisNineAfter(7, now) });
  return choices;
}

/** `Tue 09:00`, or `09:00` today */
export function parisWhen(iso: string, now = new Date()): string {
  const d = new Date(iso);
  const sameDay = parisParts(d).day === parisParts(now).day && Math.abs(d.getTime() - now.getTime()) < 86_400_000;
  return new Intl.DateTimeFormat('en-GB', { timeZone: TZ, ...(sameDay ? {} : { weekday: 'short', day: 'numeric', month: 'short' }), hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(d);
}
